import Step2y2y0 from './Step2y2y0'

export default Step2y2y0